import { capabilities } from '@/capabilities';
import { enqueueSendToNative } from '@/bridge/embeddedBridge';
import { useAccountStore } from '@/store/accountStore';

/** Embedded mode renders no web sign-in UI (owner rule 2026-07-06). When a generate action
 *  is attempted without auth under the bridge, ask Unity to present the forced sign-in
 *  (web purchasing view) instead. Returns true when the action was intercepted.
 *  Editor-standalone-auth carve-out: when standaloneAuthMode is set (Editor bypass, browser
 *  Supabase session), the web AuthDialog is the only working sign-in — do not intercept. */
export function interceptEmbeddedSignIn(needsAuth: boolean): boolean {
  if (!needsAuth || !capabilities.bridge) return false;
  if (useAccountStore.getState().standaloneAuthMode) return false;
  enqueueSendToNative('requestSignIn', {});
  return true;
}

/** The share dialog's pre-flight (owner 2026-09-24): Team Access needs a signed-in account, and
 *  Unity's uploader refuses without one — but only after a regeneration pass that can take a
 *  minute. Same rule as the AI surfaces (`needsAuth = !accountUser`): under the bridge, a
 *  signed-out user gets the forced sign-in immediately and the share does not start. */
export function interceptEmbeddedSignInForSharing(): boolean {
  return interceptEmbeddedSignIn(!useAccountStore.getState().accountUser);
}
